import React, { useState } from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import axios from "axios";
import { NewReportWizard } from ".";
import { msgActions, reportActions } from "../../redux/actions";
import { getConfiguredReportsParams } from "../../utils/utils";
import { getReportData } from "../../utils";

function NewReportWizardContainer({
  translate,
  dispatch,
  modalAddReportWizard,
  selectedReport,
  selectedReportId,
  configReportSearch,
  configuredReports,
  subUser,
  isSubUser,
  handleGridReloadCallBack,
}) {
  const [pastNextLaunchConfirmModal, setPastNextLaunchConfirmModal] =
    useState(false);
  const [reportDataToBeSaved, setReportDataToBeSaved] = useState(null);
  const [selectedReportScheduleId, setSelectedReportScheduleId] = useState("");
  const [modalAddReportWizardKeepOpen, setModalAddReportWizardKeepOpen] =
    useState(false);
  const [resetLoaderCallback, setResetLoaderCallback] = useState(null);

  const handlePageReload = () => {
    var _pageNum = configReportSearch.PageNumber;
    if (_pageNum > 0) {
      dispatch(
        reportActions.getConfiguredReports(
          getConfiguredReportsParams(
            {
              ...configReportSearch,
              PageNumber: _pageNum,
            },
            isSubUser,
            subUser ? subUser.customerGlobalId : null
          )
        )
      );
    }
  };

  const saveReport = (params, resetLoader, modalAddReportWizardKeepOpen) => {
    var isUpdate = !!selectedReport;
    let doUpdateDefinition = false;
    let doUpdateSchedule = false;

    const originalDefinitionParams = Object.assign({}, selectedReport);
    delete originalDefinitionParams["schedules"];

    const definitionParams = Object.assign({}, params);
    delete definitionParams["schedules"];

    doUpdateDefinition =
      JSON.stringify(originalDefinitionParams) !==
      JSON.stringify(definitionParams);

    // call update schudules if triggerType === "recurringreport"
    let schedulesParams;
    if (
      params.triggerType === "recurringreport" &&
      params.schedules &&
      params.schedules[0]
    ) {
      const originalSchedulesParams =
        selectedReport.schedules && selectedReport.schedules[0]
          ? Object.assign({}, selectedReport.schedules[0], {
              state: selectedReport.active ? "Pending" : "Canceled",
            })
          : null;

      schedulesParams = Object.assign({}, params.schedules[0], {
        state: params.active ? "Pending" : "Canceled",
      });

      doUpdateSchedule =
        JSON.stringify(originalSchedulesParams) !==
        JSON.stringify(schedulesParams);
    }

    if (isUpdate && selectedReportId) {
      definitionParams._id = selectedReportId;
    }
    if (isUpdate && selectedReportScheduleId) {
      schedulesParams._id = selectedReportScheduleId;
    }
    if (!isUpdate) {
      insertDefinition(
        definitionParams,
        doUpdateSchedule,
        schedulesParams,
        resetLoader,
        modalAddReportWizardKeepOpen,
        params
      );
      return;
    } else if (doUpdateDefinition) {
      updateDefinition(
        definitionParams,
        doUpdateSchedule,
        schedulesParams,
        resetLoader,
        modalAddReportWizardKeepOpen
      );
    } else if (doUpdateSchedule) {
      updateSchedule(
        { ...schedulesParams, reportdefinitionid: definitionParams._id },
        resetLoader,
        modalAddReportWizardKeepOpen
      );
    } else if (modalAddReportWizardKeepOpen) {
      if (resetLoader) resetLoader();
      dispatch(msgActions.error("Report Update", "Nothing to update"));
    } else {
      if (resetLoader) resetLoader();
      dispatch(
        msgActions.success("Report Update", "Report updated successfully")
      );
      dispatch(reportActions.toggleModalAddReportWizard(false));
      if (
        handleGridReloadCallBack &&
        typeof handleGridReloadCallBack === "function"
      ) {
        handleGridReloadCallBack();
      } else if (configuredReports) {
        handlePageReload();
      }
    }
  };

  const insertDefinition = (
    definitionParams,
    doInsertSchedule,
    schedulesParams,
    resetLoader,
    modalAddReportWizardKeepOpen,
    params
  ) => {
    axios
      .post("Reporting/Definitions/Insert", definitionParams)
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          if (resetLoader) resetLoader();
          dispatch(
            msgActions.error(
              "Report Update",
              <>
                <p>Server failed with the following errors:</p>
                {response.data.Errors.join("<br />")}
              </>
            )
          );
        } else {
          if (
            response.data.ValidationErrors &&
            response.data.ValidationErrors.length
          ) {
            if (resetLoader) resetLoader();
            dispatch(
              msgActions.error(
                "Validation Error",
                <>
                  <p>The following field(s) are missed:</p>
                  {response.data.ValidationErrors.join("<br />")}
                </>
              )
            );
          } else {
            dispatch(
              reportActions.setWizardSelectedReportId(response.data.Data._id)
            );
            if (doInsertSchedule) {
              schedulesParams["reportdefinitionid"] = response.data.Data._id;
              insertSchedule(
                schedulesParams,
                resetLoader,
                modalAddReportWizardKeepOpen,
                params
              );
            } else {
              if (resetLoader) resetLoader();
              dispatch(
                reportActions.setWizardSelectedReport(
                  JSON.parse(JSON.stringify(params))
                )
              );
              dispatch(
                msgActions.success("Report Added", "Report added successfully")
              );
              dispatch(
                reportActions.toggleModalAddReportWizard(
                  modalAddReportWizardKeepOpen
                )
              );
              if (configuredReports) {
                handlePageReload();
              }
            }
          }
        }
      });
  };

  const updateDefinition = (
    definitionParams,
    doUpdateSchedule,
    schedulesParams,
    resetLoader,
    modalAddReportWizardKeepOpen
  ) => {
    axios
      .put("Reporting/Definitions/Update", definitionParams)
      .then((response) => {
        const { Errors, ValidationErrors, Data } = response.data;
        if (Errors && Errors.length) {
          if (resetLoader) resetLoader();
          dispatch(
            msgActions.error(
              "Server Error",
              <>
                <p>Server failed with the following errors:</p>
                {Errors.join("<br />")}
              </>
            )
          );
        } else {
          if (ValidationErrors && ValidationErrors.length) {
            if (resetLoader) resetLoader();
            dispatch(
              msgActions.error(
                "Validation Error",
                <>
                  <p>The following fields are missed:</p>
                  {ValidationErrors.join("<br />")}
                </>
              )
            );
          } else if (doUpdateSchedule) {
            schedulesParams["reportdefinitionid"] = Data?._id;
            updateSchedule(
              schedulesParams,
              resetLoader,
              modalAddReportWizardKeepOpen
            );
          } else {
            // reload and close window
            if (resetLoader) resetLoader();
            dispatch(
              msgActions.success("Report Update", "Report updated successfully")
            );
            dispatch(
              reportActions.toggleModalAddReportWizard(
                modalAddReportWizardKeepOpen
              )
            );
            if (configuredReports) {
              handlePageReload();
            }
          }
        }
      });
  };

  const insertSchedule = (
    schedulesParams,
    resetLoader,
    modalAddReportWizardKeepOpen,
    params
  ) => {
    axios
      .post("Reporting/Schedules/Insert", { Data: schedulesParams })
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          if (resetLoader) resetLoader();
          dispatch(
            msgActions.error(
              "Server Error",
              <>
                <p>Server failed with the following errors:</p>
                {response.data.Errors.join("<br />")}
              </>
            )
          );
        } else {
          if (
            response.data.ValidationErrors &&
            response.data.ValidationErrors.length
          ) {
            if (resetLoader) resetLoader();
            dispatch(
              msgActions.error(
                "Validation Error",
                <>
                  <p>The following fields are missed:</p>
                  {response.data.ValidationErrors.join("<br />")}
                </>
              )
            );
          } else {
            if (resetLoader) resetLoader();
            const scheduleId = response.data.Data?._id;
            if (scheduleId) {
              setSelectedReportScheduleId(scheduleId);
              dispatch(
                reportActions.setWizardSelectedReport(
                  JSON.parse(JSON.stringify(params))
                )
              );
              dispatch(
                msgActions.success("Report Added", "Report added successfully")
              );
              dispatch(
                reportActions.toggleModalAddReportWizard(
                  modalAddReportWizardKeepOpen
                )
              );
              if (configuredReports) {
                handlePageReload();
              }
            } else {
              dispatch(msgActions.error("Schedule Adding", "Unknown error"));
            }
          }
        }
      });
  };

  const updateSchedule = (
    schedulesParams,
    resetLoader,
    modalAddReportWizardKeepOpen
  ) => {
    axios
      .put("Reporting/Schedules/Update", { Data: schedulesParams })
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          if (resetLoader) resetLoader();
          dispatch(
            msgActions.error(
              "Server Error",
              <>
                <p>Server failed with the following errors:</p>
                {response.data.Errors.join("<br />")}
              </>
            )
          );
        } else {
          if (
            response.data.ValidationErrors &&
            response.data.ValidationErrors.length
          ) {
            if (resetLoader) resetLoader();
            dispatch(
              msgActions.error(
                "Validation Error",
                <>
                  <p>The following fields are missed:</p>
                  {response.data.ValidationErrors.join("<br />")}
                </>
              )
            );
          } else {
            // reload and close window
            if (resetLoader) resetLoader();
            dispatch(
              msgActions.success("Report Update", "Report updated successfully")
            );
            dispatch(
              reportActions.toggleModalAddReportWizard(
                modalAddReportWizardKeepOpen
              )
            );
            if (configuredReports) {
              handlePageReload();
            }
          }
        }
      });
  };

  const toggleModalAddReportWizard = () => {
    dispatch(reportActions.toggleModalAddReportWizard(!modalAddReportWizard));
    dispatch(reportActions.setWizardSelectedReportId(""));
  };

  const togglePastNextLaunchConfirmModal = () => {
    setPastNextLaunchConfirmModal(!pastNextLaunchConfirmModal);
  };
  const handleYesConfirmNextLaunchDialog = () => {
    saveReport(
      reportDataToBeSaved,
      resetLoaderCallback,
      modalAddReportWizardKeepOpen
    );
    setPastNextLaunchConfirmModal(false);
    setReportDataToBeSaved(null);
  };
  const handleNoConfirmNextLaunchDialog = () => {
    setPastNextLaunchConfirmModal(false);
    setReportDataToBeSaved(null);
  };

  const handleWizardFormSubmit = (
    data,
    selectedReportType,
    resetLoader,
    keepOpen
  ) => {
    let reportData = getReportData(data, selectedReportType);
    if (
      reportData.validationErrorMsgs &&
      reportData.validationErrorMsgs.length
    ) {
      if (resetLoader) resetLoader();
      dispatch(
        msgActions.error(
          "Validation Error",
          <ListGroup>
            {reportData.validationErrorMsgs.map((item, index) => (
              <ListGroupItem
                key={index}
                dangerouslySetInnerHTML={{
                  __html: item,
                }}
              />
            ))}
          </ListGroup>
        )
      );
    } else if (reportData.schedulesConfirmRequired) {
      setPastNextLaunchConfirmModal(true);
      setReportDataToBeSaved(reportData.data);
      setResetLoaderCallback(resetLoader);
      setModalAddReportWizardKeepOpen(keepOpen);
    } else {
      saveReport(reportData.data, resetLoader, keepOpen);
    }
  };

  return (
    <>
      <NewReportWizard
        isOpen={modalAddReportWizard}
        toggle={toggleModalAddReportWizard}
        handleOnSubmit={handleWizardFormSubmit}
        reportDefinitionId={selectedReportId}
        reportPipelineDefinitionId={selectedReport.reportPipelineDefinitionId}
      />
      <Modal
        isOpen={pastNextLaunchConfirmModal}
        toggle={togglePastNextLaunchConfirmModal}
      >
        <ModalHeader toggle={togglePastNextLaunchConfirmModal}>
          {translate("ScheduleNextLaunchWarning")}
        </ModalHeader>
        <ModalBody>
          You choose a date in a past for scheduled reports. That will launch a
          generation and delivery of all the reports from the day you specified
          till current day.
          <br />
          This could lead to spamming recipients of e-mails and uploading a lot
          of files to SFTP/FTP connections.
          <br />
          Do you really want to set the date in the past?
        </ModalBody>
        <ModalFooter className="text-center">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleYesConfirmNextLaunchDialog}
          >
            {translate("Yes")}
          </button>
          <Button
            color="primary"
            className="EventSearchSubmit"
            style={{ marginLeft: "60px" }}
            onClick={handleNoConfirmNextLaunchDialog}
          >
            {translate("No")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

function mapStateToProps(state) {
  const {
    locale,
    configReportSearch,
    authentication: { user, subUser, isSubUser },
    reports: {
      configuredReports,
      modalAddReportWizard,
      selectedReport,
      selectedReportId,
      defaultReportPage,
      handleGridReloadCallBack,
    },
  } = state;
  return {
    configReportSearch,
    configuredReports,
    modalAddReportWizard,
    selectedReport,
    selectedReportId,
    defaultReportPage,
    handleGridReloadCallBack,
    user,
    subUser,
    isSubUser,
    translate: getTranslate(locale),
  };
}

const connectedNewReportWizardContainer = connect(mapStateToProps)(
  NewReportWizardContainer
);
export { connectedNewReportWizardContainer as NewReportWizardContainer };
